const mobileSelector = document.querySelector('#mobile_selector_id');

const openSelector = () => {
  mobileSelector.classList.add('mobile_selector_opened');
  let BInStock_button = document.querySelector('#BIS_trigger');
  let buttonToReplace = document.getElementById('BIS_trigger2');
  if (BInStock_button && buttonToReplace) {
      BInStock_button.classList.add("bis-btn-trigger", "btn", "btn--primary", "button--selector--variants");
      buttonToReplace.appendChild(BInStock_button); 
  }
}
const closeSelector = () => {
  mobileSelector.classList.remove('mobile_selector_opened');
  let BInStock_button = document.querySelector('#BIS_trigger');
  let buttonToReplace = document.getElementById('BIS_trigger1');
  if (BInStock_button && buttonToReplace) {
      buttonToReplace.appendChild(BInStock_button);
  }
}



///////////////// COLOR SELECTOR/////////////////////

const  colorSelectorchild = document.querySelector('#color_selector_child');
const  colorselectorParent = document.querySelector('#color_selector_parent');

if(colorSelectorchild !== null)
  colorselectorParent.appendChild(colorSelectorchild);



///////////// VARIANT SELECTOR MOBILE ////////////////

function cloneContent() {
  targetDiv.innerHTML = sourceDiv.innerHTML;
  // targetDiv.querySelector('[data-add-to-cart-text]').innerText = sourceDiv.hasAttribute('disabled') ? theme.strings.addToCart : theme.strings.addToCart + " | ";
}

window.addEventListener('DOMContentLoaded', function () {
  const cloneAddToCart = document.querySelector('#clone-addToCart'); // Select the button
  const mainElement = document.querySelector('main'); // Select the main element

  if (cloneAddToCart && mainElement) {
    // Move the clone-addToCart button directly after <main>
    mainElement.insertAdjacentElement('afterend', cloneAddToCart);
  }
});
window.addEventListener('scroll', function () {
  const stickyDiv = document.querySelector('#clone-addToCart'); // Sticky div (Add to Cart button)
  const targetDiv = document.querySelector('#mobile_selector_id'); // Div 2 (Target position)
  const desktopSelectorDiv = document.querySelector('#desktop_Selector_buttons_id'); // Div 3 (Desktop Selector Buttons)

  const targetPosition = targetDiv.getBoundingClientRect().bottom + window.scrollY; // Position of Div 2
  const stickyDivHeight = stickyDiv.offsetHeight; // Height of the sticky div
  const desktopSelectorPosition = desktopSelectorDiv.getBoundingClientRect().top; // Position of Div 3

  if (window.scrollY + window.innerHeight >= targetPosition + stickyDivHeight) {
    stickyDiv.style.visibility = 'hidden'; 
    stickyDiv.style.zIndex = -1; // Make stickyDiv hidden
  } else {
    stickyDiv.style.visibility = 'visible';
    stickyDiv.style.zIndex = 101; // Make stickyDiv sticky again at the bottom
  }
  if (desktopSelectorPosition <= 0) {
    stickyDiv.style.visibility = 'visible';
    stickyDiv.style.zIndex = 101; // Ensure it's visible and sticky
  }
});

const sourceDiv = document.querySelector('#addToCart-submit-btn');
const targetDiv = document.querySelector('#clone-addToCart');

targetDiv.addEventListener('click', (e) => {
  e.preventDefault();
  if(sourceDiv.hasAttribute('disabled')){
    sourceDiv.scrollIntoView({
      behavior: 'smooth',   // Scrolling behavior: 'auto' or 'smooth'
      block: 'center',       // Vertical alignment: 'start', 'center', 'end', or 'nearest'
      inline: 'nearest'     // Horizontal alignment: 'start', 'center', 'end', or 'nearest'
    });
  }else{
    targetDiv.classList.add('is-loading');
    targetDiv.disabled = true;
    sourceDiv.click()
    
    setTimeout(() => {
      targetDiv.classList.remove('is-loading');
      targetDiv.disabled = false;
    }, 2000);
  }
  
})



// Set up the MutationObserver to observe changes in the sourceDiv
const observer = new MutationObserver(function(mutationsList) {
  // Loop through mutations to check for changes
  mutationsList.forEach(function(mutation) {
    if (mutation.type === 'childList' || mutation.type === 'subtree' || mutation.type === 'characterData') {
      cloneContent();  // Call function to clone content on any change

    }
  });
});

// Observer options: we are watching for changes to child elements, subtree, or character data (text)
const observerOptions = {
  childList: true,  // Observes direct children of sourceDiv
  subtree: true,    // Observes all children and their descendants
  characterData: true // Observes changes in text nodes
};

// Start observing the sourceDiv for changes
observer.observe(sourceDiv, observerOptions);

// Initial clone (in case the targetDiv needs to be populated right away)
cloneContent();
